const { OB_TRUST_INFO } = require('../../constants/cookieConstants');
const { convertCookieValueToTrustInfo } = require('../../server/middlewares/trustInfo');

class TrustInfoResolver {
  #cookies = null;

  #trustInfo = null;

  constructor({ cookies, trustInfo }) {
    this.#trustInfo = trustInfo;
    this.#cookies = cookies;
  }

  async resolve() {
    if (this.#trustInfo) {
      return this.#trustInfo;
    }

    const trustInfoCookie = this.#cookies?.[OB_TRUST_INFO];

    let trustInfo = null;

    if (trustInfoCookie) {
      const { signature: _signature, timestamp: _timestamp, ...rest } = convertCookieValueToTrustInfo(trustInfoCookie);

      trustInfo = rest;
    }

    return trustInfo;
  }
}

module.exports = TrustInfoResolver;
